import React from "react";
import "./Hexagon.css";

interface HexagonProps {
  size: number;       // Size of the hexagon side
  borderWidth: number; // Width of the "border"
  innerColor: string;
  borderColor: string;
  src: string;
}

const Hexagon: React.FC<HexagonProps> = ({ size, borderWidth, innerColor, borderColor, src }) => {
  const innerSize = size - borderWidth  * 0.5;

  return (
    <div className="hexagon" style={{ width: size * 2, height: size * 1.732 }}> {/* Adjust the container size */}
      <div
        className="outer-hexagon"
        style={{
          backgroundColor: borderColor,
          clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)"
        }}
      >
        <div
          className="inner-hexagon"
          style={{
            backgroundColor: innerColor,
            width: innerSize * 2,
            height: innerSize * 1.732,
            clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
          }}
        >
          <img src={src} alt="choose-us-info-pic"/>
        </div>
      </div>
    </div>
  );
};

export default Hexagon;
